module.exports = __webpack_public_path__ + "media/images/icons/outlined/ie-1a2b9e726069bc71cbf3730ace1fae5a.svg";